module.exports = __webpack_public_path__ + "static/media/singapore.023e6c92.webp";